// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files-wrapper-card {
  border-radius: 12px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);
}

.file-item {
  padding: 12px 0;
}

/* خط جداکننده بین فایل‌ها */
.divider-line {
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
  opacity: 0.8;
}

/* استایل محتوای کارت */
.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* نام فایل */
.file-name {
  font-size: 16px;
  font-weight: 500;
  flex: 1 1;
  min-width: 100px;
}

/* دکمه دانلود */
.download-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background:#007aff;
  color: white;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 14px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.3s ease;
  justify-content: center;
  width: 150px;
  min-width: 120px;
  white-space: nowrap;
}

.download-btn:hover {
  background: #005fcc;
}

/* آیکون دانلود */
.download-icon {
  font-size: 18px;
}

/* موبایل */
@media (max-width: 600px) {
  .card-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .download-btn {
    width: 100%;
    margin-top: 8px;
    text-align: center;
  }
}


.divider-line {
  border-top: 1px solid #e0e0e0;
}

.file-type-title {
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.no-data {
  color: #999;
  padding-left: 1rem;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/views/articles/css/ArticleFiles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".files-wrapper-card {\n  border-radius: 12px;\n  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.file-item {\n  padding: 12px 0;\n}\n\n/* خط جداکننده بین فایل‌ها */\n.divider-line {\n  height: 1px;\n  background-color: #e0e0e0;\n  margin: 8px 0;\n  opacity: 0.8;\n}\n\n/* استایل محتوای کارت */\n.card-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n/* نام فایل */\n.file-name {\n  font-size: 16px;\n  font-weight: 500;\n  flex: 1;\n  min-width: 100px;\n}\n\n/* دکمه دانلود */\n.download-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background:#007aff;\n  color: white;\n  padding: 10px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: bold;\n  transition: background 0.3s ease;\n  justify-content: center;\n  width: 150px;\n  min-width: 120px;\n  white-space: nowrap;\n}\n\n.download-btn:hover {\n  background: #005fcc;\n}\n\n/* آیکون دانلود */\n.download-icon {\n  font-size: 18px;\n}\n\n/* موبایل */\n@media (max-width: 600px) {\n  .card-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .download-btn {\n    width: 100%;\n    margin-top: 8px;\n    text-align: center;\n  }\n}\n\n\n.divider-line {\n  border-top: 1px solid #e0e0e0;\n}\n\n.file-type-title {\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  font-size: 1.1rem;\n}\n\n.no-data {\n  color: #999;\n  padding-left: 1rem;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
